module.exports = __webpack_public_path__ + "img/home-line.81df8071.svg";